import React, { useMemo } from 'react';
import { EmailField, PasswordField, Avatar, BodyText, Heading3 } from '@kallidus/common';
import { useTranslation, Trans } from 'react-i18next';
import { useFormState } from 'react-final-form';
import { useAppConfig } from '@ApplicationWide/AppConfig';
import './SessionOutFormField.less';

export default function SessionOutFormFields() {
  const { t } = useTranslation();
  const { company } = useAppConfig();
  const { values } = useFormState();

  const isEmailDisabled = useMemo(() => (values[`field~username`] ? true : false), [values]);
  return (
    <>
      <div className='session-out-panel-div'>
        <Avatar className='session-out-panel-logo' src={company.baseDetails.logo} size='large' />
      </div>
      <Heading3 className='session-out-heading'>{t('auth.heading.session-out-heading')}</Heading3>
      <BodyText className='session-out-description' fade>
        <Trans
          i18nKey='auth.heading.session-out-description'
          values={{ interval: company.baseDetails.timeoutInterval }}
          components={{ bold: <strong /> }}
        />
      </BodyText>
      <EmailField
        name='username'
        label={t('auth.form-fields.email.label')}
        emailFormatErrorMessage={t('auth.form-fields.email.format-error-message')}
        emptyMessage={t('auth.form-fields.email.empty-message')}
        noTopSpacer
        required
        disabled={isEmailDisabled}
      />
      <PasswordField
        name='password'
        label={t('auth.form-fields.password.label')}
        emptyMessage={t('auth.form-fields.password.empty-message')}
        autoComplete
        required
      />
    </>
  );
}
